import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Row,
  Col,
  Collapse,
  Badge,
  Table,
  DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown,

} from "reactstrap";
import {
  Link
} from "react-router-dom";
import {imageFileExtension,getImageFile} from "../../settings/shared/commonMethod"

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { toast } from 'react-toastify';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import RunService from '../../services/api/Run';
import ProjectService from '../../services/api/Project';
import ChatService from '../../services/api/Chat';
import UserService from '../../services/api/User';
import moment from 'moment'
import { SOCKET_API_BASE_URL } from '../../settings/shared/constants';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { Scrollbars } from 'react-custom-scrollbars';
import { CopyToClipboard } from "react-copy-to-clipboard";
import TinyURL from "tinyurl";
import StorageService from '../../services/api/Storage';
import { Launcher } from '../../components/Chat/';
import Avatar from 'react-avatar';
import { jobidLoad } from '../../components/Chat/UserInput';
import { projectLoad } from '../../components/Chat/UserInput';
import { uuidv4 } from 'components/Notebook/operations/notebook';


const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }

}
class JobRun extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      chatMsg: [],
      messages: [],
      localName: null,
      localPhoto: null,
      chatDbId: null,
      socketLoadFlag: false,
      logState: false,
      logDetails: [],
      open: true,
      jobname: '',
      description: '',
      modelInputFiles: [],
      modelCodeFiles: [],
      modelOutputFiles: [],
      modelOutputCodeFiles: [],
      InputFolders: [], //new
      CodeFolders: [],  // new
      modelOutputCodeFolders:[],  //new
      modelOutputFolders: [],   //new
      parameterSet: '',
      runDBId: '',
      messageList: [],
      runId: '',
      pagehist:'',
      openedCollapses: [""],
      chatMasterId:"",
      badgeloading:false,
      jobPageNumber:0,
      chatprojectdata:[],
      chatrundata:[],
      projectDTOS:[],
      chatIdentifier:"",
      chatName:"",
      jobIds:[],
      parametersTablesdata:[],
      swidth: window.innerWidth,
      sheight: window.innerHeight

    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }

  componentDidMount() {
    this.WebsocketInit();
    this.GetAllProject();
    this.GetAllProject_Init();
    // this.LoadrunsDetails();
    this.GetRunsData();
    let currentUrl = window.location.href;
    let continuePath = new URLSearchParams((currentUrl).substring(currentUrl.indexOf('?') + 1)).get('__o')
    if(continuePath === null) {
      continuePath = "/ "
    }
    this.setState({
      pagehist : continuePath,
    },()=>{
      var pathArray = window.location.pathname.split('?');
      this.state.chatIdentifier = pathArray.toString().substring(pathArray.toString().lastIndexOf("/") + 1)
      this.LoadMessagesByIdentifier(this.state.chatIdentifier)
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    })
    
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }
  GetJobRun = (jobData) => {
     RunService.GetJobRun(jobData)
      .then((response) => {
        let parametersTables_array = []
        let parametersTables_files = response.parametersTables
        if (parametersTables_files !== null) {
          for (let index = 0; index < parametersTables_files.length; index++) {
            parametersTables_array.push(parametersTables_files[index])
          }
          this.setState({
            parametersTablesdata: parametersTables_array
          });
        }
        else{
          this.setState({
            parametersTablesdata: []
          });
        }
        this.setState({
          jobname: response.name,
          description: response.description,
          modelInputFiles: response.modelInputFiles || [],
          InputFolders: response.modelInputFolders || [], //new
          modelCodeFiles: response.modelCodeFiles || [],
          CodeFolders: response.modelCodeFolders || [],  // new
          modelOutputFiles: response.modelOutputFiles !== null?response.modelOutputFiles:[], // new
          modelOutputFolders: response.modelOutputFolders !== null?response.modelOutputFolders:[],   //new
          parameterSet: response.parameterSet,
          parametersTables: parametersTables_array,
          LogFiles: response.logEntries,
          runDBId: response.id,
          chatDbId: response.runId,
          modelOutputCodeFiles: response.modelOutputCodeFiles,
          modelOutputCodeFolders: response.modelOutputCodeFolders !== null?response.modelOutputCodeFolders:[],  //new
          chatMasterId:response.chatMasterId
        },()=>{
          //  this.LoadMessagesByJobId(this.state.chatMasterId)
        })
        //  if(this.state.chatDbId!=null){
        //   this.LoadChats(this.state.chatDbId);
        // }
        // this.LoadChats(response.id)
      })
      this.setState( { 
        badgeloading:false,
      } );
  }

  getProjectById = (id) =>{
    ProjectService.GetProjectById(id)
      .then((res) => {
        if (res.status === 'SUCCESS') {
          let response = res.projectDTOS[0];
          let parametersTables_array = []
          let parametersTables_files = response.parametersTables
          if (parametersTables_files !== null) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
          }
          this.setState({
            parametersTablesdata: parametersTables_array
          });
          this.setState({
            jobname: response.name,
            description: response.description,
            modelInputFiles: response.modelInputFiles || [],
            InputFolders: response.modelInputFolders || [], //new
            modelCodeFiles: response.modelCodeFiles || [],
            CodeFolders: response.modelCodeFolders || [],  // new
            modelOutputFiles: response.modelOutputFiles !== null?response.modelOutputFiles:[], // new
            modelOutputFolders: response.modelOutputFolders !== null?response.modelOutputFolders:[],   //new
            parameterSet: response.parameterSet,
            parametersTables: parametersTables_array,
            LogFiles: response.logEntries,
            runDBId: response.id,
            chatDbId: response.runId,
            modelOutputCodeFiles: response.modelOutputCodeFiles,
            modelOutputCodeFolders: response.modelOutputCodeFolders !== null?response.modelOutputCodeFolders:[],  //new
            chatMasterId:response.chatMasterId  
          })
        }
      });
  }

  GetAllProject = () =>{
    ProjectService.GetProject(0,50)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        let responseData = response.projectDTOSPage;
        if(responseData.content !== null){
        this.setState({
          projectDTOS:responseData.content
        });
      }
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
}

  GetAllProject_Init=()=>{
      ChatService.GetChatProject(0,2)
      .then((res) => {
        if(res !== ""){
            let size = res.totalItems;
            ChatService.GetChatProject(0,size).then((response) => {
            this.setState({chatprojectdata:response.chatItems},()=>{
              projectLoad(this.state.projectDTOS);  // store project names for chat # features
              })
            });  
            }else{
          // console.log("end scroll")
        }
      })
   }

   GetRunsData = () => {
    let postData = {
      projectId: null
    }
      // RunService.getRunbySize(postData,0,2)
      // .then((res) => {
        // if(res!=""){
            // let size = res.runDetails.totalElements;
            RunService.getRunbySize(postData,0,10).then((response) => {
              if (response.status === 'SUCCESS') {
                // let runSDTO = response.runDetails.content;
                // this.renderData(runSDTO);
                // jobidLoad(runSDTO);
                this.setState({
                  jobIds:response.runDetails.content
                },()=>{
                  this.state.jobIds.length !== 0?jobidLoad(this.state.jobIds):jobidLoad([]);
                })
              } else {
                toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
              }
            });  
        //     }else{
        //   console.log("end scroll")
        // }
      // })
  }


  LoadrunsDetails = () =>{
      ChatService.GetChatRunIds(0,2)
      .then((res) => {
        if(res !== ""){  // if chat response is 204 execure this condtion
          let size = res.totalItems;
          ChatService.GetChatRunIds(0,size).then((response) => {
          this.setState({chatrundata:response.chatItems},()=>{
              jobidLoad(this.state.chatrundata);  // store job id's for chat ## features 
            })
          });  
        }else{
          // console.log("end scroll")
        }
      })
  }


    
  LoadMessagesByJobId = (chatmasterId) =>{
    localStorage.setItem("scrollMount",true); 
    this.setState( { 
      badgeloading:true,
    } );
    let size = 20;
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
      if(chatResponse === "" || chatResponse === ""){ 
            this.setState({
                messageList: [],
                badgeloading: false
            })
      }else{
        this.setState({
                messageList: chatResponse.chat.reverse(),
                badgeloading: false
            })
      }
     });  
  }

  LoadMessagesByIdentifier = (chatIdentifier) =>{
    localStorage.setItem("scrollMount",true); 
    this.setState( { 
      badgeloading:true,
    } );
    let size = 20;
    ChatService.GetChatIdentifierMessages(chatIdentifier,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
      if(chatResponse === "" || chatResponse === ""){ 
            this.setState({
                messageList: [],
                badgeloading: false
            })
      }else{
        this.setState({
                messageList: chatResponse.chat.reverse(),
                badgeloading: false,
                chatMasterId:chatResponse.chatMasterId,
                chatIdentifier:chatResponse.chatIdentifier,
                sourceDBId:chatResponse.sourceDBId,
                jobrunid:chatResponse.jobId,
                chatName:chatResponse.chatName
            },()=>{
              this.ReadUpdateStatus(this.state.chatMasterId);
              this.state.jobrunid !== null?this.GetJobRun(this.state.jobrunid):this.getProjectById(this.state.sourceDBId);
            })
      }
     });  
  }

  ReadUpdateStatus = (chatMasterId) =>{
    let readStatusPayload = {
      chatMasterId: chatMasterId,
      userId: localStorage.getItem('Uid')
    }
    RunService.ChatUpdateReadStatus(readStatusPayload).then((response) => {    
    });
  }

  async _onMessageWasSent(message) {
    // console.log("messagemessagemessagemessage",message)
    // console.log("mediaBase64Content",message.mediaBase64Content)
    this.setState({
      badgeloading:true
    })
    let chatPayload;
     if(message.files.length === 0){
     chatPayload = {
      "messageType": message.type,
      "message": message.data,
      "mentionedUsers":message.emails,
      "chatMasterId":this.state.chatMasterId
    }
    RunService.Postchat(chatPayload)
      .then((response) => {
        let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
        let res = {
        "firstName": loggedInUser.firstName,
        "lastName": loggedInUser.lastName,
        "photoURL": null,
        "message": message.data,
        "createdDate":moment().format() ,
       
        }
        this.setState({
          messageList: [...this.state.messageList, res],
          badgeloading:false
        })
      });
     }else{
       chatPayload = {
      // "messageType": message.type,
      "message": message.data,
      // "mentionedUsers":message.emails,
      "chatMasterId":this.state.chatMasterId,
      "contentType":"application/png"
    }
    // console.log("chatPayloadddd",JSON.stringify(chatPayload))
    // console.log(message.files)
    ChatService.PostMedia(chatPayload,message.files)
      .then((response) => {
        let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
        let res = {
        "firstName": loggedInUser.firstName,
        "lastName": loggedInUser.lastName,
        "photoURL": null,
        "message": message.data,
        "createdDate":moment().format()  ,
        "mediaBase64Content":message.mediaBase64Content
        }
        this.setState({
          messageList: [...this.state.messageList, res],
          badgeloading:false
        })
      });
     }
  }
 
  async _sendMessage(text) {
    this.setState({
    badgeloading:true
  })
    if (text.length > 0) {
      this.setState({
        messageList: [...this.state.messageList, {
          author: 'them',
          type: 'text',
          data: { text }
        },
      ],
      badgeloading:false
      })
    }
  }
  //Init websocket for runs page
  WebsocketInit = () => {
    var _this = this;
    var socket = new SockJS(SOCKET_API_BASE_URL);
    var stompClient = Stomp.over(socket);
    stompClient.debug = null
    stompClient.connect('guest', 'guest', function (frame) {
      stompClient.subscribe('/topic/message' + localStorage.getItem("Uid"), function (notification) {
        // console.log(notification)
        let MyData = JSON.parse(notification.body);
        // console.log(JSON.stringify(MyData));
        if (MyData.notificationType === 'NOTIFICATION') {
          _this.setState({
            socketLoadFlag: true,
            loading: false,
          },()=>{
            var finalData = JSON.parse(MyData.message);
            if(finalData.chatMasterId === _this.state.chatMasterId){
              _this.LoadSocketMessage(_this.state.chatMasterId);
            }
          })
        }
      })
    }, function (err) {
      // console.log('err', err);
      // _this.WebsocketInit();
    });

  }

  LoadSocketMessage = (chatmasterId) =>{
    let size = 20;
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
        if(chatResponse === "" || chatResponse === ""){
          this.setState({
                messageList: this.state.messageList,
          })
        }else{
          let chat = chatResponse.chat.reverse();
            this.setState({
                messageList: [...this.state.messageList,chat[chat.length-1]],
            })
            this.ReadUpdateStatus(chatmasterId);
        }  
     });  
  }
  userselectedValue = (firstName, lastName) => {
    let myappendUser = firstName + " " + lastName + ", ";
    this.setState(prevState => ({ input: prevState.input.concat(myappendUser), showuserListFlag: false }))
  }

  keyPressed = (event) => {
    if (event.keyCode === 13) {
      this.submitMessage()
    } else if (event.keyCode === 50) {
      // console.log(this.state.UserList);
      this.setState({ showuserListFlag: true });
    } else {
      this.setState({ showuserListFlag: false });
    }
  }

  submitMessage = () => {
    this.setState(
      {
        messages: [...this.state.messages, this.state.input],
        input: ""
      }
    );
    let chatPaylad = {
      "runDBId": this.state.runDBId,
      "message": this.state.input
    }
    RunService.Postchat(chatPaylad)
      .then((response) => {
      })
  }

  clearMessages = () => {
    this.setState({ messages: [] });
  }

  // Load all chats for particular run id
   LoadChats(rundbId) {
    this.setState( { 
      loading:true,
      badgeloading:true
    } );

    let profile = JSON.parse(localStorage.getItem("UserProfile"));
    this.setState({
      localName: profile.firstName + " " + profile.lastName,
      localPhoto: profile.photoURL,
      input: '',
      messages: []
    });
    RunService.GetChats(rundbId)
      .then((response) => {
        this.state.countitem = response.length;
        // console.log('RESPONSE',response)
        this.setState({
          chatMsg: response,
          loading:false,
          badgeloading:false
        })
     
        let uId = localStorage.getItem("Uid");
        this.GetAllUsers(uId);
      })
  }
  GetAllUsers = (allid) => {
    UserService.getAllUsers(this.state.usersid)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          this.setState({
            UserList: response.userDTOS
          });
        } else {
          // console.log(response.errorMessage);
        }
      })
  }

  _onScrollLoadMessage(){
    if(localStorage.getItem("scrollMount")==='false'){
       this.LoadOlderMessagesByJobId(this.state.chatMasterId);
       this.setState({ badgeloading: false });
    }
    // this.setState({ badgeloading: true });
  }

  LoadOlderMessagesByJobId = (chatmasterId) =>{
    if (!this.state.socketLoadFlag) {
      this.setState({ badgeloading: true });
    }
    let size = 20;
    ChatService.GetChatMessages(chatmasterId,localStorage.getItem("messagePageNumber"),size).then((chatResponse) => {
        if(chatResponse === "" || chatResponse === ""){
          this.setState({
                messageList: this.state.messageList,
                // jobIdLabel: jobid,
                // runId:chatResponse.content[0].runDBId,
                badgeloading: false
          })
        }else{
          let chat = chatResponse.chat.reverse();
          for(var i=0;i<chat.length;i++){
            this.setState({
                messageList: [chat[i]].concat(this.state.messageList),
                badgeloading: false
            })
          }
        }  
     });  
  }

  handleChange = (event) => {
    this.setState({ input: event.target.value });
  }
  OpenStorageView = (name, event) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = "/job/"+this.state.chatIdentifier+"?__o="+this.state.pagehist;
    // let reg = "/admin/job?cid="+this.state.jobrunid;
    let path = name.slice(-1) === "/"?"/storage?path="+name:"/storageView?file="+name; // check folder or file
    let redirectUrl = currentUrl.replace(reg, path);
    window.open(redirectUrl, "_blank");
  }



  handleScrollRuns = (e) =>{
    e.preventDefault()
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && this.state.jobSearch === "") {
      // const {scrollbar} = this.refs;  // scrollbar has access to the internal API
      // scrollbar.scrollTop();
      this.setState((preState) => {
        return {jobPageNumber : preState.jobPageNumber + 1};
      },()=>{
        // console.log(this.state.jobPageNumber)
        // this.scrollList.scrollToTop();
        this.LoadrunsDetails("notinit")
      });
    }
  }
  copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>); 
  }
  
  GetLink = (name,event) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = "/job/"+this.state.chatIdentifier+"?__o="+this.state.pagehist;
    // let reg = "/admin/job?cid="+this.state.jobrunid;
    let redirectUrl = currentUrl.replace(reg, "/storageView?file="+name);
    
    TinyURL.shorten(redirectUrl).then((res) =>{
      this.ShareURL(res, name);
    })
  }

  ShareURL = (tinylink, fileName) => {
    this.setState({ gettinylink: tinylink });
    this.state.copylink = tinylink;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='content'>
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                    <Row >
                      <div className="col">
                      <h6><i className="fas fa-link"></i>&nbsp; Get Link </h6>
                      </div>
                      <div className="col text-right">
                        <div>
                          <span className="close clear-filter" style={{ cursor: "pointer" }} onClick={() => { onClose() }}>×</span>
                        </div>

                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col md="8">

                        <FormGroup>
                          <Input className="form-control-alternative" style={{ width: '260px' }} value={this.state.copylink}
                            onChange={({ target: { value } }) => this.setState({ value, copied: false })} />

                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <CopyToClipboard text={this.state.copylink}
                            onCopy={() => this.setState({ copied: true })}>
                            <p style={{ cursor: "pointer" }} onClick={this.copyAlert}><b>Copy Link</b></p>
                          </CopyToClipboard>
                        </FormGroup>
                      </Col>

                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>

        )
      }
    });
  }

  // Download particular file in input or code
  downloadparticularFiles = (fileName, rid, type) => {
    StorageService.downloadObjectUrl(fileName) 
    .then((response) => {
      const link = document.createElement('a');
      link.href = response.download_url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  collapsesToggle = collapse => {
    let openedCollapses = this.state.openedCollapses;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: []
      });
    } else {
      this.setState({
        openedCollapses: [collapse]
      });
    }
  };

  handleClick = (e) => {
    e.preventDefault();
      if(e.type === "contextmenu") {
        var arrt = e.currentTarget.getAttribute("data_attr_id");
        document.getElementById(arrt).click();
    }  
  }
  
  render() {
    return (
    
        <>
          <PanelHeader
            content={
              <div className="header text-center">

              </div>
            }
          />
          <div className="content">
          <LoadingOverlay
        active={this.state.loading}
        spinner={<ScaleLoader
          height={35}
          width={5}
          radius={2}
          margin={2}
          color={"#123abc"}
          loading={this.state.loading}
        />}
      >
                    <Col xs={12} md={12}>

          <Row>
          <div className="col">
                <Card className="shadow">
                  <CardHeader className=" bg-transparent">
                    {/* <CardTitle tag="h6">Job Run - {this.state.jobrunid}
                    <div className="col text-right">
                      <Link to="runs" >
                        <span className="close clear-filter">×</span>
                      </Link>
                    </div>
                    </CardTitle> */}
                    <Row className="align-items-center">
                    <div className="col">
                     {this.state.jobrunid !== null&&<h5>Job Run - {this.state.jobrunid}</h5>}
                     {this.state.jobrunid === null&&<h5>Project Name - {this.state.chatName}</h5>}

                    </div>
                    { this.state.badgeloading === true &&  <div className="chatLoading text-center">
                                  <Badge color="info" >Loading...</Badge>
                                  </div>}
                    <div className="col text-right">    
                    <Link to={this.state.pagehist} > 
                    <span className="close clear-filter">×</span>                     
                      </Link>
                    </div>
                  </Row>
                  </CardHeader>
                  <CardBody>
                  <div className="carcontent">

                  {/* <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}> */}
                    <Row>
                    <Col xs={12} sm={8} style={{borderRight: '1px solid rgb(221, 221, 221)',paddingRight: '15px',paddingLeft: '-15px'}}>
                    <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                    <Launcher
                          agentProfile={{
                          }}
                          onMessageWasSent={this._onMessageWasSent.bind(this)}
                          messageList={this.state.messageList}
                          _onScrollLoadMessage={this._onScrollLoadMessage.bind(this)}
                          showEmoji
                        />
                  </Scrollbars>
                      </Col>
                    <Col xs={12} sm={4}>
                     

                          
<Card className="card-user">
             <CardBody>
             <Scrollbars autoHeight autoHeightMin={this.state.sheight-250}>
                  <div className="chatdesp">
                    <a href="# " onClick={e => e.preventDefault()}>
                    <div><Avatar round={true} color={Avatar.getRandomColor('sitebase', ['violet', 'coral', '#851fc4','sandybrown'])} className="avatar border-gray" name= {this.state.jobname} size="50" 
                          />
                    </div>
                    <h5 className="title"> {this.state.jobname}</h5>
                    </a>
                    <p className="description"> {this.state.description}</p>
                  </div>               
                  <div
                    aria-multiselectable={true}
                    className="card-collapse"
                    id="accordion"
                    role="tablist"
                  >
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseOne"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseOne");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Model Input Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseOne"
                        )}
                      >
                        <CardBody>
                          <ul>
                            {this.state.InputFolders.map((item, index) => (
                              <li style={{marginTop:10}} className="listyle" key={uuidv4()}>
                              <span
                              className="file"
                              data-type="folder"
                              // onClick={onFileClick}
                              onClick={e => this.OpenStorageView(item, e)}
                              >
                                <a href="# " className="text-primary" style={styles.chaticon} ><u className="font13"><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                              </span>
                              </li>
                            ))}
                            </ul>
                        {this.state.modelInputFiles !== null && this.state.modelInputFiles.map((item,index)=> (
                          <div className="chatdespul" key={uuidv4()}>
                          <ul>
                            <li className="listyle">
                                    <div>
                                      <UncontrolledDropdown direction="right">
                                      <span className="file" data-type="file" data_attr_id={"codeId"+index+"f"}
                                        onContextMenu={this.handleClick}>
                                        <div>
                                          <p className="m-0 text-primary">
                                            <i className={getImageFile(imageFileExtension(item))}></i>
                                            <a href="# " className="text-primary font13" style={styles.chaticon}><u
                                               >{item}</u> </a>
                                          </p>
                                        </div>
                                      </span>
                                        <DropdownToggle tag="span" id={"codeId"+index+"f"}>
                                        </DropdownToggle>
                                        <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                          <DropdownItem
                                            onClick={e => this.OpenStorageView(item, e)}
                                          >
                                            <span >
                                              <i className="fas fa-binoculars mr-2"></i> View
                                           </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                          >
                                            <span>
                                              <i className="fas fa-download mr-2" /> Download
                                          </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.GetLink(item, e)}>
                                            <div>
                                              <i className=" fas fa-link mr-2" />
                                              <span>Get Sharable Link</span>
                                            </div>
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
                                    </li>
                                    </ul>
                                  
                          </div>
                          ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseTwo"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseTwo");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Model Code Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseTwo"
                        )}
                      >
                        <CardBody>
                        <ul>
                            {this.state.CodeFolders.map((item, index) => (
                              <li style={{marginTop:10}} className="listyle">
                              <span
                              className="file"
                              data-type="folder"
                              // onClick={onFileClick}
                              onClick={e => this.OpenStorageView(item, e)}
                              >
                                <a href="# " className="text-primary" style={styles.chaticon} ><u className="font13"><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                              </span>
                              </li>
                            ))}
                            </ul>
                        {this.state.modelCodeFiles !== null && this.state.modelCodeFiles.map((item,index) => (
                        <div className="chatdespul" key={uuidv4()}>
                          <ul>
                            <li className="listyle">
                              <div>
                                <UncontrolledDropdown direction="right">
                                <span className="file" data-type="file" data_attr_id={"codeId"+index+"g"} onContextMenu={this.handleClick}>
                                  <div>
                                    <p className="m-0 text-primary">
                                      <i className={getImageFile(imageFileExtension(item))}></i>
                                      <a href="# " className="text-primary font13" style={styles.chaticon}><u
                                          >{item}</u> </a>
                                    </p>
                                  </div>
                                </span>
                                  <DropdownToggle tag="span" id={"codeId"+index+"g"}>
                                  </DropdownToggle>
                                  <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                    <DropdownItem onClick={e=> this.OpenStorageView(item, e)}
                                      >
                                      <span>
                                        <i className="fas fa-binoculars mr-2"></i> View
                                      </span>
                                    </DropdownItem>
                                    <DropdownItem onClick={e=> this.downloadparticularFiles(item, item.runId,
                                      item.inputType)}
                                      >
                                      <span>
                                        <i className="fas fa-download mr-2" /> Download
                                      </span>
                                    </DropdownItem>
                                    <DropdownItem onClick={e=> this.GetLink(item, e)}>
                                      <div>
                                        <i className=" fas fa-link mr-2" />
                                        <span>Get Sharable Link</span>
                                      </div>
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </div>
                            </li>
                          </ul>
                        </div>
                        ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseThree"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseThree");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Output Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseThree"
                        )}
                      >
                        <CardBody>
                        <ul>
                            {this.state.modelOutputFolders.map((item, index) => (
                              <li style={{marginTop:10}} className="listyle">
                              <span
                              className="file"
                              data-type="folder"
                              // onClick={onFileClick}
                              onClick={e => this.OpenStorageView(item, e)}
                              >
                                <a href="# " className="text-primary" style={styles.chaticon} ><u className="font13"><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                              </span>
                              </li>
                            ))}
                            </ul>
                        {this.state.modelOutputFiles !== null && this.state.modelOutputFiles.map((item,index) => (
                                  <div className="chatdespul" key={uuidv4()}>
                                  <ul>
                                    <li className="listyle">
                                 <div>
                                      <UncontrolledDropdown direction="right">
                                      <span className="file" data-type="file" data_attr_id={"codeId"+index+"h"}
                                        onContextMenu={this.handleClick}>
                                        <div>
                                          <p className="m-0 text-primary">
                                            <i className={getImageFile(imageFileExtension(item))}></i>
                                            <a href="# " className="text-primary font13" style={styles.chaticon}><u
                                                >{item}</u> </a>
                                          </p>
                                        </div>
                                      </span>
                                        <DropdownToggle tag="span" id={"codeId"+index+"h"}>
                                        </DropdownToggle>
                                        <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                          <DropdownItem
                                            onClick={e => this.OpenStorageView(item, e)}
                                          >
                                            <span >
                                              <i className="fas fa-binoculars mr-2"></i> View
                                          </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                          >
                                            <span >
                                              <i className="fas fa-download mr-2" /> Download
                                            </span>
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={e => this.GetLink(item, e)}>
                                            <div>
                                              <i className=" fas fa-link mr-2" />
                                              <span>Get Sharable Link</span>
                                            </div>
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
</li>
</ul>
</div>

                                  ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                  <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseFour"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseFour");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Model Output Code Files</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseFour"
                        )}
                      >
                        <CardBody>
                        <ul>
                            {this.state.modelOutputCodeFolders.map((item, index) => (
                              <li style={{marginTop:10}} className="listyle">
                              <span
                              className="file"
                              data-type="folder"
                              // onClick={onFileClick}
                              onClick={e => this.OpenStorageView(item, e)}
                              >
                                <a href="# " className="text-primary" style={styles.chaticon} ><u className="font13"><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                              </span>
                              </li>
                            ))}
                            </ul>
                        {this.state.modelOutputCodeFiles !== null && this.state.modelOutputCodeFiles.map((item,index) => (
                                   <div className="chatdespul" key={uuidv4()}>
                                   <ul>
                                     <li className="listyle">
                                  <div>

                                  <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                  <span
                                        className="file"
                                        data-type="file"
                                        data_attr_id={"codeId"+index+"i"}
                                        onContextMenu={this.handleClick}
                                      >  
                                        <span className="text-primary"><i className={getImageFile(imageFileExtension(item))}></i></span>
                                        <a href="# " className="text-primary" style={styles.chaticon} ><u>{item}</u> </a>
                                      </span>
                                    <DropdownToggle tag="span" id={"codeId"+index+"i"}>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                    <DropdownItem
                                        onClick={e => this.OpenStorageView(item, e)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item, e)}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>

                                    </div>
</li>
</ul>
</div>
                                  ))}
                        </CardBody>
                      </Collapse>
                    </Card>
                    <Card className="card-plain">
                      <CardHeader role="tab">
                        <a
                          aria-expanded={this.state.openedCollapses.includes(
                            "collapseFive"
                          )}
                          href="#pablo"
                          data-parent="#accordion"
                          data-toggle="collapse"
                          onClick={e => {
                            e.preventDefault();
                            this.collapsesToggle("collapseFive");
                          }}
                        >
                          <b style={{color:'black',fontSize:'13px'}}> Business Levers</b> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                        </a>
                      </CardHeader>
                      <Collapse
                        role="tabpanel"
                        isOpen={this.state.openedCollapses.includes(
                          "collapseFive"
                        )}
                      >
                        <CardBody>
                        <Scrollbars autoHeight >
                        {this.state.parametersTablesdata.length > 0 &&
                        <div>
                        <Table responsive className="table-hover paratbl"
                          id="tab_logic"
                        >
                          <thead>
                            <tr>
                              <th>Variables </th>
                              <th style={{ width: "80%" }}> Values </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.parametersTablesdata.map((item, index) => (
                              item.row !== false &&
                              <tr id="addr0" key={index}>
                                <td className="variabletxt">{item.key}</td>
                                <td style={{ width: "80%" }}>
                                  <Input
                                    className="form-control-alternative valuetxt"
                                    defaultValue={item.value}
                                    style={{ border: 'none', borderRadius: '5px' }}
                                    id={uuidv4()} 
                                    disabled
                                    name="parameterSet"
                                    type="text"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        </div>
                        }
                          {this.state.parametersTablesdata.length === 0 && <span style={{color: 'darkgray', fontSize: '14px'}}>  &nbsp; No Business Levers Found</span>}
                                  </Scrollbars>
                        </CardBody>
                      </Collapse>
                    </Card>
               
              
               </div>
               </Scrollbars>
                </CardBody>
                </Card>


                    

                      </Col>
                    </Row>
                  {/* </Scrollbars> */}
                  </div>

                  </CardBody>
                </Card>
              </div>
           </Row>
           </Col>

           </LoadingOverlay>

          </div>
        </>
    );
  }
}

export default JobRun;
